export default (function (_ref) {
  var request = _ref.request;
  return {
    /**
       * @description 订单列表
       * @description http://yapi.xiya.vip/project/11/interface/api/75
       */
    DEVICE_BILL_ALL: function DEVICE_BILL_ALL() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/api/device-bill/index',
        method: 'post',
        data: query
      });
    },

    /**
       * @description 新闻创建
       * @description http://yapi.xiya.vip/project/11/interface/api/80
       */
    DEVICE_BILL_CREATE: function DEVICE_BILL_CREATE(data) {
      return request({
        url: '/api/device-bill/create',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 字典详情
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    DEVICE_BILL_DETAIL: function DEVICE_BILL_DETAIL(id) {
      return request({
        url: '/api/device-bill/update',
        method: 'post',
        data: {
          id: id
        }
      });
    },

    /**
       * @description 字典编辑
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    DEVICE_BILL_UPDATE: function DEVICE_BILL_UPDATE(data) {
      return request({
        url: '/api/device-bill/update',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 新闻删除
       * @description http://yapi.xiya.vip/project/11/interface/api/90
       */
    DEVICE_BILL_DELETE: function DEVICE_BILL_DELETE(id) {
      return request({
        url: '/api/device-bill/delete',
        method: 'delete',
        data: {
          id: id
        }
      });
    }
  };
});